import { Button, message, Result } from "antd";
import LoadingScreen from "components/common/layout/LoadingScreen";
import strings from "localisation/strings";
import Paths, { WithToken } from "navigation/Paths";
import React, { useEffect, useState } from "react";
import { Redirect, RouteComponentProps } from "react-router";
import useEmailAuth from "state/hooks/useEmailAuth";
import { AuthErrorTypes } from "__gen__/authGatewaySdk";

export default ({ match }: RouteComponentProps<WithToken>) => {
  const { token } = match.params;
  const [finished, setFinished] = useState(false);
  const { emailVerification, loading, errorType } = useEmailAuth();

  useEffect(() => {
    emailVerification(token).then(() => setFinished(true));
    // eslint-disable-next-line
  }, []);

  if (loading) {
    return <LoadingScreen />;
  }

  if (errorType === AuthErrorTypes.INVALID_VERIFICATION_TOKEN) {
    return (
      <Result
        status="403"
        title="This token can't be used"
        extra={<Button onClick={() => window.location.reload()}>RELOAD</Button>}
      />
    );
  }

  if (finished) {
    message.success(strings("emailVerified"));
    return <Redirect to={Paths.projects.withParams()} />;
  }

  return null;
};
